/* global attachEvent, resetVideoPlayer */

// Open sidebar
attachEvent('.tv-fullscreen__sidebar-trigger', 'click', (ev) => {
  const parentElem = ev.target.closest('.tv-fullscreen');
  parentElem.classList.toggle('is-open-sidebar');
});

const closeFullscreenVideo = () => {
  const streamOriginal = document.querySelector('.tv-fullscreen.is-open-modal .video__iframe-container');

  document.querySelectorAll('.tv-fullscreen.is-open-modal').forEach((el) => {
    el.classList.remove('is-open-modal');

    // Reset current video
    if (el.querySelector('[data-video-wrapper]')) {
      const videoParent = el.querySelector('[data-video-wrapper]');
      resetVideoPlayer(videoParent);
    } else {
      const videoParent = el.querySelector('[data-video-wrapper-stream]');
      const streamIframe = videoParent.querySelector('.video__iframe-container');
      const video = videoParent.querySelector('.video');
      streamOriginal.src = streamIframe.src.replace('?&autoplay=1', '');
      video.classList.remove('is-playing');

      const oldVideo = document.querySelector('.concert-video .video__iframe-container');
      oldVideo.src += '?&autoplay=1';
    }
  });
};

attachEvent('.tv-fullscreen__close', 'click', () => closeFullscreenVideo());

// Close tv fullscreen
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    closeFullscreenVideo();
  }
});
